import { Component, OnInit, Input } from '@angular/core';
import { Facturacion } from '../../Models/facturacion';

@Component({
  selector: 'app-ciclo-facturacion',
  templateUrl: './ciclo-facturacion.component.html',
  styleUrls: ['./ciclo-facturacion.component.css']
})

export class CicloFacturacionComponent implements OnInit {
  @Input()
  item: Facturacion;

  constructor() { }

  ngOnInit(): void{
  }
}
